import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SubscriptionPageComponent} from './subscription-page/subscription-page.component';
import {SharedModule} from '@sharedModules/shared-module/shared-module.module';
import {SubscriptionRoutingModule} from '@pages/layout/subscription/subscription-routing.module';
import {CreateProgramSubscriptionComponent} from '@pages/layout/program/program-page/program-payment/create-program-subscription/create-program-subscription.component';
import {StudentSubscriptionPageComponent} from './student-subscription-page/student-subscription-page.component';
import {AdminSubscriptionPageComponent} from './admin-subscription-page/admin-subscription-page.component';
import {AddSubscriptionPageComponent} from './add-subscription-page/add-subscription-page.component';
import {EditSubscriptionPageComponent} from './edit-subscription-page/edit-subscription-page.component';
import {ScenarioPageComponent} from './scenario/scenario-page/scenario-page.component';
import {ScenarioAddComponent} from './scenario/scenario-add/scenario-add.component';
import {ScenarioEditComponent} from './scenario/scenario-edit/scenario-edit.component';
// import { StudentSubscriptionPageComponent, DemoDialog } from './student-subscription-page/student-subscription-page.component';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {PaymentService} from '@services/payment/payment.service';
// import {PaymentsPageComponent} from '@pages/layout/payments/payments-page/payments-page.component';
import {TermsComponent} from '@components/terms/terms.component';
import {TermsPdfComponent} from '@components/terms-pdf/terms-pdf.component';
import {OnboardingRegisterComponent} from '@components/onboarding-register/onboarding-register.component';
import {ManageAdminSubscriptionDialog} from '@components/manage-admin-subscription-dialog/manage-admin-subscription-dialog.component';
import {RechargeFailedChargeStudentDialog} from '@components/recharge-failed-charge-student-dialog/recharge-failed-charge-student-dialog.component';
import {SubscriptionStudentsListComponent} from '@pages/layout/program/program-page/program-payment/subscription-students-list-popup/subscription-students-list-popup.component';
import {MatSortModule} from "@node_modules/@angular/material";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        SubscriptionRoutingModule,
        MatSortModule
    ],
  declarations: [SubscriptionPageComponent, StudentSubscriptionPageComponent,
    AdminSubscriptionPageComponent, AddSubscriptionPageComponent,
    EditSubscriptionPageComponent,
    ScenarioPageComponent,
    ScenarioAddComponent,
    ScenarioEditComponent,
    SubscriptionStudentsListComponent,
  ],
  entryComponents: [
    CreateProgramSubscriptionComponent,
    ConfirmModalComponent,
    TermsComponent,
    TermsPdfComponent,
    OnboardingRegisterComponent,
    ManageAdminSubscriptionDialog,
    RechargeFailedChargeStudentDialog,
    SubscriptionStudentsListComponent,
  ],
  exports: [
    StudentSubscriptionPageComponent
  ],
  providers: [PaymentService]
})
export class SubscriptionModule {
}
